import PeopleIcon from '@material-ui/icons/People'

import { DeveloperCreate } from './Create/Create';
import { DeveloperEdit } from './Edit/Edit';
import { DevelopersList } from './List/List';


export {
	DevelopersList,
	DeveloperCreate,
	DeveloperEdit,
}


export const developersResource = {
	list: DevelopersList,
	edit: DeveloperEdit,
	create: DeveloperCreate,
	icon: PeopleIcon,
}
